import { useHashRoute } from '../hooks/useHashRoute';
import { CoinPage } from './CoinPage';
import { DashboardPage } from './DashboardPage';
import { InfoPage } from './InfoPage';
import { NotFoundPage } from './NotFoundPage';

export function App(): React.JSX.Element {
  const route = useHashRoute();
  if (route.name === 'coin') return <CoinPage symbol={route.symbol} />;
  if (route.name === 'dashboard') return <DashboardPage />;
  if (route.name === 'info') return <InfoPage page={route.page} />;
  return <NotFoundPage />;
}
